import { Icon } from './Icons.jsx';

// Mesmas 4 regras usadas no cadastro (SignUpScreen) e na troca de senha
// (ProfileEditScreen) — validação client-side espelha `iam.password_rules`
// (min 8, 1 maiúscula, 1 minúscula, 1 número, ver iam_config.yaml).
export const PASSWORD_RULES = [
  { id: 'len', label: 'Mínimo de 8 caracteres', test: (p) => p.length >= 8 },
  { id: 'upper', label: '1 letra maiúscula (A-Z)', test: (p) => /[A-Z]/.test(p) },
  { id: 'lower', label: '1 letra minúscula (a-z)', test: (p) => /[a-z]/.test(p) },
  { id: 'digit', label: '1 número (0-9)', test: (p) => /\d/.test(p) },
];

export function PasswordRules({ rules, active }) {
  return (
    <div style={{
      padding: '12px 14px', borderRadius: 'var(--r-md)',
      background: active ? 'var(--white)' : 'var(--marble-soft)',
      border: '1px solid var(--border)',
      marginTop: -6,
      transition: 'background 0.15s',
    }}>
      <div style={{
        fontSize: 11, fontWeight: 700, color: 'var(--text-muted)',
        textTransform: 'uppercase', letterSpacing: '0.06em',
        fontFamily: 'var(--font-display)', marginBottom: 8,
      }}>
        A senha precisa ter
      </div>
      <ul aria-live="polite" style={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 6 }}>
        {rules.map(r => (
          <li key={r.id} style={{
            display: 'flex', alignItems: 'center', gap: 6,
            fontSize: 12, color: r.ok ? 'var(--success)' : 'var(--text-muted)',
            fontWeight: r.ok ? 600 : 400,
            transition: 'color 0.15s',
          }}>
            <span style={{
              width: 16, height: 16, borderRadius: 99, flexShrink: 0,
              background: r.ok ? 'var(--success)' : 'transparent',
              border: r.ok ? 'none' : '1.5px solid var(--border-strong)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              transition: 'all 0.15s',
            }}>
              {r.ok && <Icon.check size={10} color="var(--white)" strokeWidth={3.5}/>}
            </span>
            {r.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
